// src/constants/listingStatus.js
// Statuts des annonces - NE PAS MODIFIER

export const LISTING_STATUS = {
    DRAFT: 'draft',           // Brouillon (admin seulement)
    PENDING: 'pending',       // En attente de validation (admin)
    PUBLISHED: 'published',   // Publié (visible sur l'app)
    REJECTED: 'rejected',     // Rejeté par admin
    DISABLED: 'disabled',     // Désactivé (par admin ou propriétaire)
  };
  
  // Labels pour affichage
  export const LISTING_STATUS_LABELS = {
    draft: 'Brouillon',
    pending: 'En attente',
    published: 'Publié',
    rejected: 'Rejeté',
    disabled: 'Désactivé',
  };
  
  // Couleurs pour chaque statut
  export const LISTING_STATUS_COLORS = {
    draft: '#A0AEC0',      // Gris
    pending: '#ED8936',    // Orange
    published: '#48BB78',  // Vert
    rejected: '#F56565',   // Rouge
    disabled: '#4A5568',   // Gris foncé
  };
  
  // Transitions autorisées (quel statut peut aller à quel statut)
  export const STATUS_TRANSITIONS = {
    draft: ['pending', 'deleted'],
    pending: ['published', 'rejected', 'draft'],
    published: ['disabled', 'pending'],
    rejected: ['pending', 'draft'],
    disabled: ['published', 'deleted'],
  };
  
  // Qui peut modifier le statut?
  export const STATUS_MODIFIERS = {
    draft: ['SUPER_ADMIN', 'ADMIN', 'EDITOR'],
    pending: ['SUPER_ADMIN', 'ADMIN'],
    published: ['SUPER_ADMIN', 'ADMIN', 'OWNER'],
    rejected: ['SUPER_ADMIN', 'ADMIN'],
    disabled: ['SUPER_ADMIN', 'ADMIN', 'OWNER'],
  };